var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOnboardingArrowIcon = function SvgOnboardingArrowIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61.313,
    height: 30.346,
    viewBox: "0 0 61.313 30.346",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-arrow-955177",
    transform: "translate(0 9.18) rotate(-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4527",
    "data-name": "Caminho 4527",
    d: "M684.307,418.4c2.157,1.6,4.15,3.3,6.455,4.707A43.976,43.976,0,0,0,706,428.465a59.152,59.152,0,0,0,15.6.228c4.624-.407,8.98-2.241,13.562-2.757-.557-1.039-3.166-2.033-4.692-2.434-2.415-.815-4.2-1.585-6.653-2.33-2.058-.628-1.493-3.964.592-3.331,2.746.834,4.817,1.572,7.48,2.59,2.36.9,5.432,2.2,7.234,4.14a1.748,1.748,0,0,1,.456,2.011,31.891,31.891,0,0,1-9.8,12.274c-1.758,1.295-3.688-1.482-1.936-2.774a26.28,26.28,0,0,0,6.228-6.61c-4.432.683-8.769,2.287-13.283,2.684a60.6,60.6,0,0,1-17.534-.775,46.054,46.054,0,0,1-14.764-5.727A60.88,60.88,0,0,1,682.145,421C679.571,418.929,681.947,416.649,684.307,418.4Z",
    transform: "translate(-681.03 -417.761)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnboardingArrowIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onboarding-arrow-icon.ee2457b1.svg";
export { ForwardRef as ReactComponent };